'use client';

import { c as _c } from "react/compiler-runtime";
import type { Address, ChainId } from '@morpho-org/blue-sdk';
import { Icon } from '@repo/ui';
import { Timelock } from '@repo/ui/icons';
import { memo } from 'react';
import { PendingActionsList, VaultPendingTimelockInfo } from '@/components/VaultPage/components/VaultPendingTimelockInfo';
import { VaultPendingTimelockChangeGuardian, VaultPendingTimelockChangeTimelock, VaultPendingTimelockCountdown } from '@/components/VaultPage/VaultV1/VaultPendingTimelock/components';
import { StyledVaultPendingTimelock } from '@/components/VaultPage/VaultV1/VaultPendingTimelock/VaultPendingTimelock.components';
import type { GuardianMetadataItems, VaultPendingTimelocks } from '../TimelockDurationDataLine/types';
interface PendingTimelocksIndicatorProps {
  chainId: ChainId;
  pendingTimelocks: VaultPendingTimelocks;
  address?: Address;
  currentGuardianMetadata?: GuardianMetadataItems;
}
const PendingTimelocksIndicator = t0 => {
  const $ = _c(15);
  const {
    pendingTimelocks,
    chainId,
    address,
    currentGuardianMetadata
  } = t0;
  const t1 = pendingTimelocks.length;
  let t2;
  if ($[0] !== address || $[1] !== chainId || $[2] !== currentGuardianMetadata || $[3] !== pendingTimelocks) {
    let t3;
    if ($[5] !== address || $[6] !== chainId || $[7] !== currentGuardianMetadata) {
      t3 = (t4, index) => {
        const {
          decodedData,
          functionName,
          validAt
        } = t4;
        return <StyledVaultPendingTimelock.Container key={`${functionName}-${index}`} selectable={false}>{decodedData.__typename === "VaultSetGuardianPendingData" && <VaultPendingTimelockChangeGuardian chainId={chainId} functionName={functionName} currentGuardian={address} currentGuardianMetadata={currentGuardianMetadata} newGuardian={decodedData.guardian.address} newGuardianMetadata={decodedData.guardian.metadata.items ?? undefined} />}{decodedData.__typename === "VaultSetTimelockPendingData" && <VaultPendingTimelockChangeTimelock functionName={functionName} timelock={decodedData.timelock} />}<VaultPendingTimelockCountdown validAt={validAt} /></StyledVaultPendingTimelock.Container>;
      };
      $[5] = address;
      $[6] = chainId;
      $[7] = currentGuardianMetadata;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = pendingTimelocks.map(t3);
    $[0] = address;
    $[1] = chainId;
    $[2] = currentGuardianMetadata;
    $[3] = pendingTimelocks;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[9] !== pendingTimelocks.length || $[10] !== t2) {
    t3 = <PendingActionsList count={t1}>{t2}</PendingActionsList>;
    $[9] = pendingTimelocks.length;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const pendingActionsContent = t3;
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon className="text-info-foreground hover:text-info-foreground" icon={<Timelock />} />;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== pendingActionsContent) {
    t5 = <VaultPendingTimelockInfo content={pendingActionsContent}>{t4}</VaultPendingTimelockInfo>;
    $[13] = pendingActionsContent;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default memo(PendingTimelocksIndicator);